import { useState } from 'react';

// Creaturetype, player, ally, monster
const ToggleButton = ({title, checked, cKey, creatureType, side, handlePvOptionChange}) => {
    const [toggle, setToggle] = useState(checked)
    
    const toggleClick = (e) => {
        handlePvOptionChange(creatureType, cKey, e.target.checked)
        setToggle(!toggle)
    }

    return (
        <div className={`pVChecks ${side === 1 ? "pVCheckLeft" : ""}`}> 
            {side === 1 && <>{title}</>} 
            <input type="checkbox" checked={toggle} onChange={(e) => toggleClick(e)}/>
            {side === 2 && <>{title}</>}
        </div>
    );
}

export default ToggleButton;